import { render, staticRenderFns } from "./PlacementBooking.vue?vue&type=template&id=1c41d320&scoped=true"
import script from "./PlacementBooking.vue?vue&type=script&lang=js"
export * from "./PlacementBooking.vue?vue&type=script&lang=js"
import style0 from "./PlacementBooking.vue?vue&type=style&index=0&id=1c41d320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41d320",
  null
  
)

export default component.exports